import { PageShell } from '../components/PageShell';
import { colors, cardStyle } from '../theme';

export function HelpPage() {
  return (
    <PageShell>
      <h1 style={{ fontSize: 20, fontWeight: 700, color: colors.text, margin: 0, marginBottom: 20 }}>
        Help
      </h1>
      <div style={{ ...cardStyle, padding: 24, maxWidth: 640 }}>
        <h2 style={{ fontSize: 16, margin: '0 0 8px', color: colors.text }}>Putting an app online</h2>
        <p style={{ fontSize: 14, color: colors.text, lineHeight: 1.6, margin: '0 0 16px' }}>
          Drop your project folder or a ZIP on the Home page (or import it from GitHub). We work out
          what it is built with, set it up and give you a secure link to share.
        </p>
        <h2 style={{ fontSize: 16, margin: '0 0 8px', color: colors.text }}>If your app shows &ldquo;Needs attention&rdquo;</h2>
        <p style={{ fontSize: 14, color: colors.text, lineHeight: 1.6, margin: '0 0 16px' }}>
          Most often a setting is missing. Click <strong>Fix issue</strong> to review and change your
          app&apos;s settings, then it restarts automatically.
        </p>
        <h2 style={{ fontSize: 16, margin: '0 0 8px', color: colors.text }}>Still stuck?</h2>
        <p style={{ fontSize: 14, color: colors.text, lineHeight: 1.6, margin: 0 }}>
          Message the SRE Platform team on Slack and tell us the name of your app.
        </p>
      </div>
    </PageShell>
  );
}
